import { useContext } from 'react';
import { UserContext } from '../../context';
import { useIsPersonalizationEnabled } from './useIsPersonalizationEnabled';

export const useIsFollowAllowed = () => {
  const isPersonalizationEnabled = useIsPersonalizationEnabled();

  const { isAnonymous } = useContext(UserContext).userProfile;

  return isPersonalizationEnabled && !isAnonymous;
};
